/**
 * @license BCP
 * (c) 2016 Openprovider. http://openprovider.eu
 * @author Igor Dolzhikov idolzhikov@openprovider.nl
 * License: MIT
 */
(function() {'use strict';

/**
 * @ngdoc module
 * @name revisions
 * @description
 *
 * # revisions
 *
 * The `revisions` module enable to view revisions history.
 */
angular.module("revisions", [])
  .constant("revisionsDefaultPageSize", 10)
  .constant("revisionsPageSizes", [10, 25, 50, 100])
  .constant("revisionsControlSize", 10)
/**
 * @ngdoc controller
 * @name revisionsCtrl
 * @requires $location, b17Service, userCache
 *
 * @description
 * Revisions Controller
 */
  .controller("revisionsCtrl", function (
    $location, b17Service, userCache,
    revisionsDefaultPageSize, revisionsPageSizes, revisionsControlSize, exportToCsv) {

    var ctrl = this;

    ctrl.ld = _;

    // init error and info messages
    ctrl.errorMessage = null;
    ctrl.infoMessage = null;

    ctrl.location = $location.path();

    ctrl.selectedSection = userCache.get('revisionsSelectedSection');
    
    ctrl.data = {
      versions: [],
      releases: [],
      prices: [],
      promotions: [],
    };

    // -------------
    // GET REST DATA
    // -------------

    b17Service.getConfig().then(function (config) {
      if (config.data && config.data.data) {
        ctrl.data.config = config.data.data.results[0];
        if (angular.isUndefined(ctrl.selectedVersion)) {
          ctrl.selectedVersion = ctrl.data.config.version;
        }
      } else {
        checkErrorCodeMessage();
      }
    });

    // get editions data (price versions)
    b17Service.getEditions().then(function (editions) {
      if (editions.data && editions.data.data) {
        ctrl.data.versions = _.sortBy(editions.data.data.results, 'number');
        ctrl.data.versions.forEach(function (item) {
	        // get releases data (price releases)
          b17Service.getReleases({
              edition: item.number,
              cache: false
            }).then(function (releases) {
            if (releases.data && releases.data.data) {
              ctrl.data.releases[item.number] = _.sortBy(releases.data.data.results, 'number');
            } else {
              checkErrorCodeMessage();
            }
          });
        });
      } else {
        checkErrorCodeMessage();
      }
    });

    // get promotions data
    b17Service.getPromotions({cache: false}).then(function (promotions) {
      if (promotions.data && promotions.data.data) {
        ctrl.data.promotions = promotions.data.data.results;
      } else {
        checkErrorCodeMessage();
      }
    });

    // ----------
    // PAGINATION
    // ----------

    // init pagination
    ctrl.defaultPageSize = revisionsDefaultPageSize;
    ctrl.pageSizes = revisionsPageSizes;
    ctrl.controlMaxSize = revisionsControlSize;
    ctrl.pricesPageSize = userCache.get('revisionsPricesPageSize') || revisionsDefaultPageSize;
    ctrl.pricesCurrentPage = userCache.get('revisionsPricesCurrentPage') || 1;
    ctrl.promotionsPageSize = userCache.get('revisionsPromotionsPageSize') || revisionsDefaultPageSize;
    ctrl.promotionsCurrentPage = userCache.get('revisionsPromotionsCurrentPage') || 1;

    ctrl.pricesPageChanged = function() {
      userCache.put('revisionsPricesCurrentPage', ctrl.pricesCurrentPage);
    };
    ctrl.promotionsPageChanged = function() {
      userCache.put('revisionsPromotionsCurrentPage', ctrl.promotionsCurrentPage);
    };

    // select prices page size
    ctrl.selectPricesPageSize = function (count) {
      ctrl.pricesPageSize = count;
      userCache.put('revisionsPricesPageSize', count);
      ctrl.pricesCurrentPage = 1;
      ctrl.pricesPageChanged();
    };
    // select promotions page size
    ctrl.selectPromotionsPageSize = function (count) {
      ctrl.promotionsPageSize = count;
      userCache.put('revisionsPromotionsPageSize', count);
      ctrl.promotionsCurrentPage = 1;
      ctrl.promotionsPageChanged();
    };

    // ---------
    // SELECTORS
    // ---------

    // select setcion of the import
    ctrl.selectSection = function (section) {
      ctrl.selectedSection = section;
      userCache.put('revisionsSelectedSection', section);
    };

    // select versions
    ctrl.selectVersion = function (version) {
      ctrl.selectedVersion = version;
      userCache.put('revisionsSelectedVersion', version);
      ctrl.pricesCurrentPage = 1;
      ctrl.pricesPageChanged();
      ctrl.promotionsCurrentPage = 1;
      ctrl.promotionsPageChanged();
    };

    // -------------------
    // BREADCRUMB & RESETS
    // -------------------

    ctrl.checkBreadcrumb = function (name) {
      return (angular.isDefined(ctrl.selectedSection) ? 
        ctrl.selectedSection === name : (name === 'all' ? true : false));
    };

    ctrl.showAll = function () {
      ctrl.selectedSection = 'all';
      userCache.put('revisionsSelectedSection', 'all');
    };
            
    // -------
    // FILTERS
    // -------

    ctrl.versionFilter = function (item) {
      return angular.isUndefined(ctrl.selectedVersion) ||
        ctrl.selectedVersion === null ||
        item.version === ctrl.selectedVersion;
    };

    // -------
    // GETTERS
    // -------

    // get version description
    ctrl.getVersionDescription = function () {
      var versionDescription = "All versions";
      if (ctrl.selectedVersion) {
        ctrl.data.versions.forEach(function (version) {
          if (version.number === ctrl.selectedVersion) {
            versionDescription = version.description;
          }
        });
      }
      return versionDescription;
    };

    ctrl.openPrices = function (item) {
      item.prices = [];
      b17Service.getPrices({
        version: item.number,
        legacy: 'true',
      }).then(function (prices) {
        if (prices.data && prices.data.data) {
          item.prices = prices.data.data.results;
        } else {
          checkErrorCodeMessage();
        }
      });
    };

    // clear error message
    ctrl.dismissError = function() {
      ctrl.errorMessage = null;
    };

    // clear info message
    ctrl.dismissInfo = function() {
      ctrl.infoMessage = null;
    };

    // -----------------
    // SERVICE FUNCTIONS
    // -----------------

    function checkErrorCodeMessage() {
      if (userCache.get('lastErrorCode')) {
        ctrl.errorMessage = 'Error: (' + userCache.get('lastErrorCode') + ') ' + userCache.get('lastErrorMessage');
      } else {
        ctrl.errorMessage = 'Unknown error, please check connection to the service.';
      }
    }

    // -------------------------------------------
    // EXPORT TO CSV, created by Eugene Semennikov
    // -------------------------------------------

    ctrl.exportAllProductRecordsToCsv = exportToCsv.downloadAllProductRecordsToFile;

  });

})();
